import React from 'react';
/* eslint-disable no-restricted-syntax */
import { Query } from '@apollo/react-components';

import AppBanner from './AppBanner';
import appBannerQuery from './appBannerQuery';

type QueryResult = {
  data:
    | {
        appImplementationById: {
          id: string;
          banner: 'beta' | 'by-invite' | 'deprecated' | 'premium';
        };
      }
    | null
    | undefined;
};

type SmartAppBannerProps = {
  api: string | null | undefined;
};

const SmartAppBanner = (props: SmartAppBannerProps) => (
  <Query query={appBannerQuery} skip={!props.api} variables={{ id: props.api }}>
    {(result: QueryResult) => {
      const { data } = result;

      if (!data?.appImplementationById) {
        return null;
      }

      return <AppBanner banner={data.appImplementationById.banner} />;
    }}
  </Query>
);

export default SmartAppBanner;
